export const WASEL_SET_USER = 'WASEL_SET_USER';
export const WASEL_RESET = 'WASEL_RESET';

export const ANALYTICS_IDENTITY = 'ANALYTICS_IDENTITY';
export const ANALYTICS_RESET = 'ANALYTICS_RESET';
